/** Comenzi Ultra (App-Ultra.dc.html) — listă joburi cu status + „Cum funcționează Ultra". */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useUltraJobs } from '../api/hooks';
import { EmptyState, PageHeader, SkeletonCard } from '../components/ui';
import { UltraStatusBadge } from '../components/ultra';
import { formatDateShort } from '../lib/format';

export function UltraPage() {
  const jobs = useUltraJobs();
  useEffect(() => {
    document.title = 'Comenzi Ultra — Reclame Video';
  }, []);

  const items = jobs.data?.items ?? [];

  return (
    <div>
      <PageHeader
        title="Comenzi Ultra"
        subtitle="Clipuri finisate de un editor uman în 12–48h. Urmărești statusul, vorbești cu editorul și ceri revizii."
      />

      <div className="card" style={{ padding: 16, marginBottom: 18, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        <span style={{ fontSize: 13.5, fontWeight: 800 }}>Cum funcționează Ultra:</span>
        <span className="mono" style={{ fontSize: 12.5, color: 'var(--accent-text)', fontWeight: 700 }}>
          Comandat → AI a generat → Editor lucrează → Livrat
        </span>
      </div>

      {jobs.isLoading ? (
        <div className="grid-auto">{[0, 1].map((i) => <SkeletonCard key={i} />)}</div>
      ) : items.length === 0 ? (
        <EmptyState
          illustration="🎬"
          title="Nicio comandă Ultra încă"
          body="Creează un clip Ultra și, la pasul de preview, trimite-l editorului cu un brief."
          cta={<Link to="/creeaza" className="btn btn-primary">Creează clip Ultra</Link>}
        />
      ) : (
        <div className="grid-auto" data-testid="ultra-jobs">
          {items.map((j) => (
            <Link key={j.id} to={`/ultra/${j.id}`} className="card" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10, textDecoration: 'none', color: 'var(--ink)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontWeight: 800 }}>Clip Ultra</span>
                <UltraStatusBadge status={j.status} />
              </div>
              <span style={{ fontSize: 12.5, color: 'var(--muted)' }}>
                {j.slaDeadline ? `Livrare estimată: ${formatDateShort(j.slaDeadline)}` : 'În coada editorului'}
              </span>
              <span style={{ fontSize: 12, color: 'var(--muted)' }}>Revizii rămase: {j.revisionsLeft}/{j.revisionsIncluded}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
